export class GenericError extends Error {
  name: string = 'GenericError'
}
